<template>
  <div class="p-3">
    <h4 class="header-title mt-0 mb-1">{{$t('function.form.information')}} </h4>
    <p class="sub-header"></p>

    <div class="row">

      <div class="col-12">
        <TextField 
          :placeholder="$t('function.form.name.placeholder')"
          :label="$t('function.form.name.label')"
          v-model="model.name"
          :error="$v.model.name.$error"
          :errorMessage="$v.model.name.errorMessage"
        />
      </div>

    </div>
  </div>
</template>

<script>
import  FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    TextField: () => import('@components/form2/textfield')
  },
  mixins: [ FormMixin ],
  data(){
    return {
      model:{
        name: '',
        remarks: '',
      },
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
}
</script>